import React from "react";
import Resorts from "../components/Resorts";

// ** Tanstack
import {
    QueryClient,
    QueryClientProvider,
  } from "@tanstack/react-query";

type Props = {};

// Create a client
const queryClient = new QueryClient();

const App = (props: Props) => {
  return (
    <QueryClientProvider client={queryClient}>
      <Resorts />
    </QueryClientProvider>
  );
};

export default App;
